import { FormTypes } from '../globalDestServiceConstants';
import {
  createInternationalSchoolingColumns,
  createInternationalTrainingPostRequest,
  createInternationalTrainingPutRequest,
  createInternationalTrainingRows
} from '../formData/schoolingFormData';
import { showToast } from 'modules/layout/layout.actions';
import { useCreateDataHandler } from '../apiHandlers/useCreateDataHandler';
import { useDeleteDataHandler } from '../apiHandlers/useDeleteDataHandler';
import { useFetchGlobalDestinationServiceDataHandler } from '../apiHandlers/useFetchDataHandler';
import { useUpdateDataHandler } from '../apiHandlers/useUpdateDataHandler';
import CrudTable from 'modules/clients/details/crudTable.component';
import React, { useRef, useState } from 'react';
import SpinnerComponent from 'modules/common/spinner.component';

const InternationalSchoolingCrudTable = ({
  authId,
  globalId,
  isReadOnly,
  enumerations,
  schoolingData,
  vendors,
  vendorContacts,
  familyMembers,
  countries,
  allVendors
}) => {
  const createDataHandler = useCreateDataHandler(showToast);
  const updateDataHandler = useUpdateDataHandler(showToast);
  const deleteDataHandler = useDeleteDataHandler(showToast);
  const dataHandler = useFetchGlobalDestinationServiceDataHandler(showToast);

  const [isLocalLoading, setIsLocalLoading] = useState(false);
  const scrollPositionRef = useRef(0);
  const containerRef = useRef(null);

  const handleCrudOperation = async (operation, ...args) => {
    scrollPositionRef.current = window.scrollY;
    setIsLocalLoading(true);
    const response = await operation(...args);
    if (response) {
      await dataHandler.fetchData(authId);
    }
    setTimeout(() => {
      window.scrollTo(0, scrollPositionRef.current);
      setIsLocalLoading(false);
    }, 0);
    return response;
  };

  const updateRow = async (originalRow, newRow) => {
    return await handleCrudOperation(
      updateDataHandler.updateData,
      FormTypes.InternationalSchooling,
      authId,
      globalId,
      schoolingData[originalRow.index].globalIntlSchoolingServiceId,
      createInternationalTrainingPutRequest(schoolingData[originalRow.index], newRow, globalId)
    );
  };

  const createRow = async newRow => {
    return await handleCrudOperation(
      createDataHandler.createData,
      FormTypes.InternationalSchooling,
      authId,
      globalId,
      createInternationalTrainingPostRequest(newRow, globalId)
    );
  };

  const deleteRow = async rowToDelete => {
    return await handleCrudOperation(
      deleteDataHandler.deleteData,
      FormTypes.InternationalSchooling,
      authId,
      globalId,
      rowToDelete.original.globalIntlSchoolingServiceId
    );
  };

  return (
    <div style={{ minHeight: '200px', position: 'relative' }} ref={containerRef}>
      {isLocalLoading ? (
        <div style={{ position: 'absolute', display: 'flex' }}>
          <SpinnerComponent />
        </div>
      ) : (
        <CrudTable
          editingMode="modal"
          columns={createInternationalSchoolingColumns(vendors, vendorContacts, familyMembers, enumerations, countries, allVendors)}
          rows={createInternationalTrainingRows(schoolingData, familyMembers)}
          updateRow={updateRow}
          createRow={createRow}
          deleteRow={deleteRow}
          customAddText="Add International Schooling"
          hideEdit={isReadOnly}
          toolbarCustomButton
          customButtonText="Order Service"
          customButtonMethod={() => alert('Order Service Letter Sent Successfully!')}
        />
      )}
    </div>
  );
};

export default InternationalSchoolingCrudTable;
